import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type FacilityCreationFailedAction = {
	type: 'FACILITY_CREATION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): FacilityCreationFailedAction => ({
	type: 'FACILITY_CREATION_FAILED',
	payload,
});
